module.exports = __webpack_public_path__ + "img/crate-base.bb968c86.png";